import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SapOldProfitCenterService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SapOldProfitCenterCreateDto,
  SapOldProfitCenterDto,
  SapOldProfitCenterExcelDownloadDto,
  SapOldProfitCenterUpdateDto,
} from '../proxy/controlling/dtos/sap-old-profit-center';
import { SAPOLDPROFITCENTER_CONFIG, SAPOLDPROFITCENTER_FIELDS } from './sap-old-profit-center.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-sap-old-profit-center',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SapOldProfitCenterService, ConfirmationService],
  templateUrl: './sap-old-profit-center.html',
  styleUrl: './sap-old-profit-center.scss',
})
export class SapOldProfitCenter extends BaseHierarchicalCrudComponent<
  SapOldProfitCenterDto,
  SapOldProfitCenterCreateDto,
  SapOldProfitCenterUpdateDto,
  SapOldProfitCenterExcelDownloadDto
> {
  service = inject(SapOldProfitCenterService);
  config = SAPOLDPROFITCENTER_CONFIG;
  fields = SAPOLDPROFITCENTER_FIELDS;

  protected prepareUpdateDto(data: any, selected: SapOldProfitCenterDto): SapOldProfitCenterUpdateDto {
    return {
      ...data,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SapOldProfitCenter';
  }
}
